import { render, staticRenderFns } from "./RptIngresosGastos.vue?vue&type=template&id=566c3d7f&"
import script from "./RptIngresosGastos.vue?vue&type=script&lang=js&"
export * from "./RptIngresosGastos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports